export default __webpack_public_path__ + "347359602b768caec54e168766144819.png";